import UserProfile from './UserProfile'

export default class User {
  constructor() {
    this.id = null
    this.username = ''
    this.full_name = ''
    this.email = ''
    this.password = ''
    this.abilities = []
    this.roles = []
    this.sites = []
    this.client_sites = []
    this.active = false
    this.password_changed = null
    this.profile = new UserProfile
    this.company = ''
    this.mobile = ''
    this.dialing_code = ''
    this.region_id = ''
    this.industry_id = ''
    this.notification_subscriptions = []
    this.timezone = ''
  }
}
